import ReactGA from "react-ga";

export const GAHandler = (category, action, label) => {
  ReactGA.event({
    category: category,
    action: action,
    label: label ? label : null
  });
};
